import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { Messages } from '../../codegen/Localize';
import { Location } from '../../common/react/Location';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { IUserInfo } from '../models/IUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { IResult } from '../ServerApi/types/IResponse';
import { RemoveSelfFromAlertsAction } from '../services/RemoveSelfFromAlertsAction';
import { ServerService } from '../services/ServerService';

export interface AddUserToDataAlertScope extends ng.IScope {
  dataAlertId: string; // from AngularDirective parent scope
  dataAlert: IDataAlertInfo;
  errorOccurred: boolean;
  actionSuccessful: boolean;
  errorOrSuccessMessage: string;
  undoMessage: string;
  undo: () => void;
  getUserDataAlertsUrl: () => string;
}

export class AddUserToDataAlertCtrl {

  public static $inject = [
    '$scope',
    'DataAlerts',
    'ServerService',
    'RemoveSelfFromAlertsAction'
  ];

  public initComplete: ng.IPromise<void>;

  constructor(private $scope: AddUserToDataAlertScope,
              private DataAlerts: DataAlerts,
              ServerService: ServerService,
              private RemoveSelfFromAlertsAction: RemoveSelfFromAlertsAction) {

    $scope.errorOccurred = false;
    $scope.actionSuccessful = false;
    $scope.undoMessage = Messages.addSelfToAlertThroughEmailRemoveMe();

    const currentUser = ServerService.sessionUserInfo();

    const siteUrls = siteUrlsSelector(appStore.getState());
    const userDataAlertsUrl = siteUrls.userDataAlertsUrl(currentUser.username, currentUser.domainName);

    $scope.getUserDataAlertsUrl = (): string => {
      return userDataAlertsUrl;
    };

    $scope.undo = () => {
      return this.RemoveSelfFromAlertsAction.removeSelf(Set.singletonForIdItem(this.$scope.dataAlert), { scope: $scope })
        .then(() => Location.instance.setUrl(userDataAlertsUrl));
    };

    this.initComplete = DataAlerts.getById(this.$scope.dataAlertId)
      .then((dataAlert: IDataAlertInfo) => {
        if (dataAlert) {
          this.$scope.dataAlert = dataAlert;
          if (dataAlert.isCurrentUserSubscribed) {
            this.handleUserAlreadyAddedToAlert(dataAlert);
          } else {
            this.tryToAddSelfToAlert(dataAlert, currentUser);
          }
        } else {
          this.handleAlertNotFound();
        }
      })
      .catch(()=> {
        this.handleUnknownError();
      });
  }

  private tryToAddSelfToAlert(dataAlert: IDataAlertInfo, currentUser: IUserInfo) {
    this.DataAlerts.addUsers({ dataAlertIds: [ dataAlert.id ], userIds: [ currentUser.id ] })
      .then((result: IResult) => {
        if (result.errors && result.errors.length > 0) {
            if (result.errors[0].code === 10011) {
              this.handleAddSelfNoEmailAddressError(dataAlert);
            } else {
              this.handleAddSelfError(dataAlert);
            }
        } else {
          this.handleAddSelfSuccess(dataAlert);
        }
      })
      .catch(() => {
        this.handleUnknownError();
      });
  }

  private handleAlertNotFound() {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = Messages.errorDataAlertNotFoundNoName();
  }

  private handleUserAlreadyAddedToAlert(dataAlert: IDataAlertInfo) {
    // Don't set the errorOccurred flag here because this case is success-ish
    this.$scope.actionSuccessful = true;
    this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertsErrorAlreadyAdded({ ALERT_NAME: dataAlert.name });
  }

  private handleAddSelfSuccess(dataAlert: IDataAlertInfo) {
    this.$scope.actionSuccessful = true;
    this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertThroughEmailSuccess({ ALERT_NAME: dataAlert.name });
  }

  private handleAddSelfError(dataAlert: IDataAlertInfo) {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertThroughEmailError({ ALERT_NAME: dataAlert.name });
  }
  private handleUnknownError() {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = Messages.errorUnknown();
  }

  private handleAddSelfNoEmailAddressError(dataAlert: IDataAlertInfo) {
      this.$scope.errorOccurred = true;
      this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertsErrorNoEmailAddress({ ALERT_NAME: dataAlert.name });
  }
}

Module.instance().controller('AddUserToDataAlertCtrl', AddUserToDataAlertCtrl);

